import { injectable } from 'inversify';
import container from '@core/di';
import BaseStore from '@core/stores/base';
import { TreatmentPlans } from '@shared/models/treatmentplans';
import TreatmentPlansService from '@shared/services/treatmentplans';

@injectable()
export default class TreatmentPlanStore extends BaseStore<TreatmentPlans, TreatmentPlansService> {
  static diToken = Symbol('treatment-plans');

  constructor() {
    super({ service: container.get<TreatmentPlansService>(TreatmentPlansService.diToken) });

    this.loading = {
      list: true,
      item: false,
    };
  }

  getNotApprovedTreatmentPlans = async (page, pageSize) => {
    return await this.service.getNotApprovedTreatmentPlans(page, pageSize);
  };

  getApprovedTreatmentPlans = async (page, pageSize, childId: number) => {
    return await this.service.GetApprovedTreatmentPlans(page, pageSize, childId);
  };

  approveTreatmentPlan = async (childId: number) => {
    return await this.service.ApproveTreatmentPlan(childId);
  };

  rejectTreatmentPlan = async (childId: number, rejectionNote: string) => {
    return await this.service.RejectTreatmentPlan(childId, rejectionNote);
  };

  regenerateTreatmentPlan = async (childId: number) => {
    return await this.service.RegenerateTreatmentPlan(childId);
  };

  getTreatmentOptions = async (childId: number) => {
    return await this.service.GetTreatmentOptions(childId);
  };

  getRejectedTreatmentPlans = async (assessmentId: number) => {
    return await this.service.GetRejectedTreatmentPlans(assessmentId);
  };

  getTreatmentPlanOptions = async (treatmentPlanId: number) => {
    return await this.service.GetTreatmentPlanOptions(treatmentPlanId);
  };

  downloadAssessmentSpreadsheet = async (assessmentId: number) => {
    return await this.service.downloadAssessmentSpreadsheet(assessmentId);
  };

  downloadAssessmentPdf = async (assessmentId: number, withNotes = false) => {
    return await this.service.downloadAssessmentPdf(assessmentId, withNotes);
  };

  downloadTreatmentPlanPdf = async (treatmentPlanId: number) => {
    return await this.service.downloadTreatmentPlanPdf(treatmentPlanId);
  };
}
